var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-6 h-6",
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.355 11.862h32.573V2H13.355v9.862zm2-2h28.572V4.001H15.355v5.861zM2 11.862h9.861V2H2v9.862zm2-2h5.862V4.001H4v5.861zm9.355 13.355h32.573v-9.861H13.355v9.861zm2-2h28.572v-5.861H15.355v5.861zM2 23.217h9.861v-9.861H2v9.861zm2-2h5.862v-5.861H4v5.861zm9.355 13.355h32.573v-9.861H13.355v9.861zm2-2h28.572V26.71H15.355v5.862zM2 34.572h9.861v-9.861H2v9.861zm2-2h5.862V26.71H4v5.862zm9.355 13.355h32.573v-9.861H13.355v9.861zm2-1.999h28.572v-5.862H15.355v5.862zM2 45.927h9.861v-9.861H2v9.861zm2-1.999h5.862v-5.862H4v5.862z",
    fill: "#2E27AD",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.7769ab1693350a38ba985ba4fd9bb760.svg";
export { ForwardRef as ReactComponent };